import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { dbg } from './debug';

const firebaseConfig = {
  apiKey: 'AIzaSyCSeI-a10E_oJ_R63S5JkVskqec2tdjrCo',
  authDomain: 'dissertationisland.firebaseapp.com',
  databaseURL: 'https://dissertationisland-default-rtdb.firebaseio.com',
  projectId: 'dissertationisland',
  storageBucket: 'dissertationisland.firebasestorage.app',
  messagingSenderId: '668599949185',
  appId: '1:668599949185:web:6ab5b237e89cc42b377a80',
};

dbg('boot', 'firebase: initializing', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  databaseURL: firebaseConfig.databaseURL,
});

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);

dbg('boot', 'firebase: ready', { name: firebaseApp.name });
